import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '@auth0/auth0-angular';
import { BasePowerProService } from './base-power-pro.service';

@Injectable()
export class UserService extends BasePowerProService {
  public communitiesUrl = `${this.baseUrl}/user/communities`;

  public loadCommunities(): Observable<unknown> {
    return this.get(this.communitiesUrl);
  }
}
